import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia, Box } from '@mui/material';
import { Email, LinkedIn } from '@mui/icons-material';
import '../styles/animations.css';

const Founders = () => {
  const founders = [
    {
      id: 1,
      name: 'Arpit Jhamb',
      role: 'Founder',
      image: '/images/founders/arpit-jhamb.jpg',
      bio: 'With over 15 years of experience in real estate, Arpit Jhamb has been instrumental in shaping the vision of 4 Roots Realty. His expertise in market analysis and strategic planning has helped establish the company as a trusted name in the industry.',
      email: 'arpit@4rootsrealty.com',
      linkedin: 'https://linkedin.com/in/arpit-jhamb',
      video: 'https://www.youtube.com/embed/FOUNDER_VIDEO_ID_1'
    },
    {
      id: 2,
      name: 'Aditya Monga',
      role: 'Co-Founder',
      image: '/images/founders/aditya-monga.jpg',
      bio: 'Aditya Monga brings innovative thinking and technological expertise to 4 Roots Realty. His focus on digital transformation and customer experience has revolutionized how we connect with our clients and deliver value.',
      email: 'aditya@4rootsrealty.com',
      linkedin: 'https://linkedin.com/in/aditya-monga',
      video: 'https://www.youtube.com/embed/FOUNDER_VIDEO_ID_2'
    }
  ];

  return (
    <Container sx={{ py: 8 }}>
      <Typography 
        variant="h2" 
        align="center" 
        gutterBottom
        className="animate-fadeInUp"
      >
        Founder's Desk
      </Typography>
      <Typography 
        variant="h5" 
        align="center" 
        color="text.secondary" 
        paragraph
        className="animate-fadeInUp delay-100"
      >
        Meet the visionaries behind 4 Roots Realty
      </Typography>

      <Grid container spacing={6}>
        {founders.map((founder, index) => (
          <Grid item xs={12} key={founder.id}>
            <Card 
              sx={{ height: '100%' }}
              className={`animate-scaleIn hover-scale delay-${index * 200}`}
            >
              <Grid container>
                <Grid item xs={12} md={4}>
                  <Box sx={{ position: 'relative', height: '100%', minHeight: 400 }}>
                    <CardMedia
                      component="img"
                      sx={{ height: '100%', objectFit: 'cover' }}
                      image={founder.image}
                      alt={founder.name}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={8}>
                  <CardContent sx={{ p: 4 }}>
                    <Typography variant="h3" gutterBottom>
                      {founder.name}
                    </Typography>
                    <Typography variant="h5" color="primary" gutterBottom>
                      {founder.role}
                    </Typography>
                    
                    <Typography variant="body1" paragraph sx={{ mt: 3 }}>
                      {founder.bio}
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Email color="primary" />
                        <Typography variant="body2">
                          {founder.email}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <LinkedIn color="primary" />
                        <Typography variant="body2" component="a" href={founder.linkedin} target="_blank">
                          LinkedIn Profile
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ mt: 4 }}>
                      <Typography variant="h6" gutterBottom>
                        Message from {founder.name}
                      </Typography>
                      <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
                        <iframe
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%'
                          }}
                          src={founder.video}
                          title={`Message from ${founder.name}`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        />
                      </Box>
                    </Box>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Founders; 